//import logo from './logo.svg';
import './App.css';
import TodoList from './components/TodoList';

function App() {
  return (
    <div className="todo-app" >
      <TodoList/>
    </div>
  );
}

export default App;
